import { getMonthDateDayDisplay } from "../../utils/utils"

export const getOrderFormMailSubject 
  = (date) => `【丸伊伊那青果】${getMonthDateDayDisplay(date)} 注文のご案内`

export const getOrderFormMailText
  = (clientName, officemanName, date) => (
    `${clientName}　ご担当者様\n`
    + "\n"
    + "毎度お世話になっております。\n"
    + `丸伊伊那青果　事務担当です。\n`
    + "\n"
    + `本日${getMonthDateDayDisplay(date)}の注文票を更新いたしました。\n`
    + "\n"
    + "注文ご希望の際は、下記注文専用サイトにアクセスしたうえで、\n"
    + "希望商品の注文数をご入力いただき、注文確定をお願いいたします。\n"
    + "\n"
    + "------------\n"
    + "【お取引先様　注文専用サイト】\n"
    + "http://i-seika.com/ \n"
    + "------------\n"
    + "\n"
    + "ご注文お待ちしております。\n"
    + "\n"
    + "************\n"
    + "丸伊伊那青果株式会社\n"
    + `事務担当\n`
    + "TEL : (0265) 74-5588\n"
    + "FAX : (0265) 73-7210\n"
  )

export const getSupplierOrderFormMailSubject 
  = (date) => `【丸伊伊那青果】${getMonthDateDayDisplay(date)} 発注書`

export const getSupplierOrderFormMailText
  = (supplierName, officemanName, date) => (
    `${supplierName}　ご担当者様\n`
    + "\n"
    + "毎度お世話になっております。\n"
    + `丸伊伊那青果　事務担当です。\n`
    + "\n"
    + `${getMonthDateDayDisplay(date)}分の発注を、添付の発注書のとおり申し込みます。\n`
    + "\n"
    + "お手数をおかけいたしますが、発注書をご確認いただき、\n"
    + "商品の発送をお願いいたします。\n"
    + "\n"
    + "以上、よろしくお願いいたします。\n"
    + "\n"
    + "************\n"
    + "丸伊伊那青果株式会社\n"
    + `事務担当\n`
    + "TEL : (0265) 74-5588\n"
    + "FAX : (0265) 73-7210\n"
  )

export const getSupplierWeeklyOrderFormMailSubject 
  = (date_start, date_end) => `【丸伊伊那青果】${getMonthDateDayDisplay(date_start)}～${getMonthDateDayDisplay(date_end)} 週間発注表`

export const getSupplierWeeklyOrderFormMailText
  = (supplierName, officemanName, date_start, date_end) => (
    `${supplierName}　ご担当者様\n`
    + "\n"
    + "毎度お世話になっております。\n"
    + `丸伊伊那青果　事務担当です。\n`
    + "\n"
    + `${getMonthDateDayDisplay(date_start)}～${getMonthDateDayDisplay(date_end)}分の発注を、添付の週間発注表のとおり申し込みます。\n`
    + "\n"
    + "お手数をおかけいたしますが、週間発注表をご確認いただき、\n"
    + "各期日にて商品の発送をお願いいたします。\n"
    + "\n"
    + "以上、よろしくお願いいたします。\n"
    + "\n"
    + "************\n"
    + "丸伊伊那青果株式会社\n"
    + `事務担当\n`
    + "TEL : (0265) 74-5588\n"
    + "FAX : (0265) 73-7210\n"
  )

export const getBasicPriceMailSubject 
  = (date) => `【丸伊伊那青果】${getMonthDateDayDisplay(date)} 注文のご案内`

export const getBasicPriceMailText
  = (clientName, officemanName, date) => (
    `${clientName}　ご担当者様\n`
    + "\n"
    + "毎度お世話になっております。\n"
    + `丸伊伊那青果　事務担当です。\n`
    + "\n"
    + `本日${getMonthDateDayDisplay(date)}の基本価格表を更新いたしました。\n`
    + "\n"
    + "注文ご希望の際は、下記注文専用サイトにアクセスしたうえで、\n"
    + "希望商品の注文数をご入力いただき、注文確定をお願いいたします。\n"
    + "\n"
    + "------------\n"
    + "【お取引先様　注文専用サイト】\n"
    + "http://i-seika.com/\n"
    + "------------\n"
    + "\n"
    + "ご注文お待ちしております。\n"
    + "\n"
    + "************\n"
    + "丸伊伊那青果株式会社\n"
    + `事務担当\n`
    + "TEL : (0265) 74-5588\n"
    + "FAX : (0265) 73-7210\n"
  )

